import { render, staticRenderFns } from "./ClinicOfDoctor.vue?vue&type=template&id=261ccfc4&scoped=true"
import script from "./ClinicOfDoctor.vue?vue&type=script&lang=js"
export * from "./ClinicOfDoctor.vue?vue&type=script&lang=js"
import style0 from "./ClinicOfDoctor.vue?vue&type=style&index=0&id=261ccfc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261ccfc4",
  null
  
)

export default component.exports